module.exports = __webpack_public_path__ + "static/img/Riley-Mcgree copy.3a4475a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Riley-Mcgree copy.jpg
// module id = s1NH
// module chunks = 0